import { SortOrder } from "sprint-common-web";

import { ContentVersionSource } from "../../../../common/types/ContentVersionSource";
import { EpisodeVersionListingItem } from "./EpisodeVersionListingItem";

export interface EpisodeVersionListingFilters {
    page: number;
    pageSize: number;
    sortBy: keyof EpisodeVersionListingItem;
    sortOrder: SortOrder;
    sources?: ContentVersionSource[];
    includeMerged?: boolean;
}

export const episodeVersionOrigins = [
    ContentVersionSource.Sprint,
    ContentVersionSource.Buzz,
    ContentVersionSource.Trailer
];

export const defaultEpisodeVersionListingFilters: EpisodeVersionListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "distributorName",
    sortOrder: "asc",
    sources: episodeVersionOrigins,
    includeMerged: false
};
